import { useEffect } from "react";
import { useQuery } from "react-query";
import axios from "axios";

import { SiReactos } from "react-icons/si";

import ProjectCard from "./ProjectCard";
import { repository, changePageState, Page } from "../Interfaces";

const Projects = ({ setCurrentPage }: changePageState) => {
  useEffect(() => setCurrentPage(Page.projects), [setCurrentPage]);
  const { data, isLoading, error } = useQuery<repository[], Error>(
    "repos",
    async () => {
      const all_data = await axios({
        url: "https://api.github.com/users/aayush-musyaju/repos",
        method: "GET",
        headers: {
          Accept: "application/vnd.github.v3+json",
        },
      }).then((resp) => resp.data);

      const process_data: repository[] = await Promise.all(
        all_data.map(async (repo: any) => {
          const lang = await axios.get(repo.languages_url).then((resp) => {
            return Object.keys(resp.data);
          });
          return {
            name: repo.name,
            description: repo.description,
            url: repo.html_url,
            languages: lang,
            has_pages: repo.has_pages,
            homepage: repo.homepage,
            fork: repo.fork,
          };
        })
      );

      return process_data;
    }
  );

  if (isLoading) return <SiReactos className="projects__spinner" />;
  if (error) return <div>{error.message}</div>;

  return (
    <div className="projects flex flex-c flex-ac">
      {data!.map((repo: repository, index: number) => (
        <ProjectCard key={repo.name + index} repo={repo} />
      ))}
    </div>
  );
};

export default Projects;
